<template>
  <el-form :ref="alias" v-bind="$attrs" v-on="$listeners">
    <slot />
    <el-form-item v-for="(formheader, $index) in formHeaders" :key="$index" :label="formheader.label" :prop="formheader.prop">
      <!--自定义插槽-->
      <template v-if="formheader.slot">
        <slot :name="formheader.slot" />
      </template>
      <!--输入框-->
      <template v-else-if="isInputType(formheader.type)">
        <base-input v-model="form[formheader.prop]" :type="formheader.type" :options="formheader" />
      </template>
      <!--下拉框-->
      <template v-else-if="(formheader.type) === 'select'">
        <el-select v-model="form[formheader.prop]">
          <el-option v-for="(option, index) in formheader.options" :key="index" :label="option.label" :value="option.value" />
        </el-select>
      </template>
      <!--开关-->
      <template v-else-if="(formheader.type) === 'switch'">
        <el-switch v-model="form[formheader.prop]" />
      </template>
      <!--多选框-->
      <template v-else-if="(formheader.type) === 'checkbox'">
        <el-checkbox-group v-model="form[formheader.prop]">
          <el-checkbox v-for="(option, index) in formheader.options" :key="index" :label="option.label" :value="option.value" :name="formheader.prop" />
        </el-checkbox-group>
      </template>
      <!--单选框-->
      <template v-else-if="(formheader.type) === 'radio'">
        <el-radio-group v-model="form[formheader.prop]">
          <el-radio v-for="(option, index) in formheader.options" :key="index" :label="option.label" :true-label="option.value" />
        </el-radio-group>
      </template>
      <template v-else-if="(formheader.type) === 'timeSelect'">
        <base-time-select v-model="form[formheader.prop]" :options="formheader" />
      </template>
      <template v-else-if="formheader.type === 'timePicker' || formheader.type === 'time'">
        <base-time-picker v-model="form[formheader.prop]" :options="formheader" />
      </template>
      <template v-else-if="(formheader.type) === 'date'">
        <base-date-picker v-model="form[formheader.prop]" :options="formheader" />
      </template>
    </el-form-item>

    <slot name="foot">
      <el-form-item v-if="showDefaultFoot" label-width="0" style="text-align: center">
        <slot name="btn-before" />
        <el-button type="primary" @click="submit(alias)">
          {{ confirmBtnText }}
        </el-button>
        <slot name="btn-middle" />
        <!--<el-button @click="resetFields('form')">重置</el-button>-->
        <el-button v-if="showCancel" @click="cancel">
          {{ cancelBtnText }}
        </el-button>
        <slot name="btn-after" />
      </el-form-item>
    </slot>
  </el-form>
</template>

<script>
export default {
  name: 'MtForm',
  props: {
    confirmBtnText: {
      type: String,
      default: '确定'
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showDefaultFoot: {
      type: Boolean,
      default: true
    },
    alias: {
      type: String,
      default: 'form'
    },
    value: {
      type: Object,
      default: function() {
        return Object.create(null)
      }
    },
    formHeaders: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      inputTypeList: ['input', 'password', 'textarea'],
      form: this.value
    }
  },
  computed: {
    isInputType() {
      return function(type) {
        return this.inputTypeList.includes(type)
      }
    }
  },
  methods: {
    cancel() {
      this.resetFields(this.alias)
      this.$emit('cancel')
    },
    submit(formName = this.alias) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('submit')
        } else {
          this.$emit('submitError')
          return false
        }
      })
    },
    validateElement(val) { this.$refs[this.alias].validateElement(val) },
    validateField(val) { this.$refs[this.alias].validateField(val) },
    resetFields(formName = this.alias) { this.$refs[formName].resetFields() },
    clearValidate(val) { this.$refs[this.alias].clearValidate(val) }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Mt/MtForm/index.vue